import React from "react";

export function StarRating({ value = 0, count = 0, size = 14 }) {
  const full = Math.round(value);
  return (
    <span className="inline-flex items-center gap-1" data-testid="star-rating">
      <span aria-label={`${value} stars`} style={{ color: "var(--gf-accent)" }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <svg key={i} width={size} height={size} viewBox="0 0 24 24"
               fill={i <= full ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5"
               style={{ display: "inline-block", marginRight: 1 }}>
            <polygon points="12,2 15,9 22,9.5 17,14.5 18.5,22 12,18 5.5,22 7,14.5 2,9.5 9,9" />
          </svg>
        ))}
      </span>
      <span className="text-xs" style={{ color: "var(--gf-text-muted)" }}>
        {count > 0 ? `${value.toFixed(1)} (${count})` : "No reviews yet"}
      </span>
    </span>
  );
}
